import { QTY_SCALE } from '@bnn/shared';

/**
 * Ask for confirmation at or above this quantity (in the counted unit) — spec §8.4.
 * Stock is mostly in the thousands, so a low threshold would fire on almost every entry and be
 * clicked through unread. The review screen highlights the largest entries instead.
 */
export const LARGE_QTY = 100_000n;
/** Per-UoM overrides (uom_code → threshold); empty = LARGE_QTY for every unit. */
export const LARGE_QTY_BY_UOM: Readonly<Record<string, bigint>> = {};

/** qty is a scaled integer from parseDecimal(…, QTY_SCALE). */
export const isLargeQty = (qty: bigint, uom?: string) => qty >= (LARGE_QTY_BY_UOM[uom ?? ''] ?? LARGE_QTY) * 10n ** BigInt(QTY_SCALE);

/** The review screen marks this many highest entries of a session "ยอดสูง — ตรวจก่อนปิดรอบ". */
export const REVIEW_TOP_QTY = 20;

/**
 * A void reason made only of digits (and separators) is almost always the new quantity typed in
 * the wrong place — the counter wanted "แก้ยอด", not "ยกเลิก".
 */
export const looksLikeQty = (reason: string) => /^[\d\s.,]+$/.test(reason.trim()) && /\d/.test(reason);
